<template>
  <div class="user-edit">
    <UserForm />
  </div>
</template>

<script>
import UserForm from './UserForm';

export default {
  name: 'UserEdit',
  components: { UserForm },
  mounted() {
    this.$store.dispatch('users/loadForm', this.$route.params.id);
  },
};
</script>

<style scoped>
</style>
